// eslint-disable-next-line import/prefer-default-export
export const INDIVIDUAL_DISTANCE_GOAL = 60;
